import React from 'react'
import { Modal, Button } from 'antd'
import { withTranslation } from 'react-i18next'
import './styles.less'

const ModalInactive = ({ showModal, setShowModal, timeout = 0, t: copy }) => {
  return (
    <div>
      <Modal className='modal-inactive-container' centered visible={showModal} footer={null}>
        <h4>{copy('scenes.inactive_modal_title')}</h4>
        <p>{copy('scenes.inactive_modal', { timeout })}</p>
        <div className='button-container'>
          <Button key='ok' type='primary' onClick={() => setShowModal(false)}>
            {copy('scenes.button_ok', { timeout })}
          </Button>
        </div>
      </Modal>
    </div>
  )
}

export default withTranslation()(ModalInactive)
